import { render } from "./CartBody.vue?vue&type=template&id=185283de&scoped=true"
import script from "./CartBody.vue?vue&type=script&lang=js"
export * from "./CartBody.vue?vue&type=script&lang=js"

import "./CartBody.vue?vue&type=style&index=0&id=185283de&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185283de"]])

export default __exports__